import { useMutation } from '@tanstack/react-query'
import { verifyOtp } from '../index'

const useVerifyOtp = () =>
  useMutation({
    mutationFn: verifyOtp,
  })

export default useVerifyOtp
